<ng-container *ngIf="isLoading$ | async">
    <div class="loading-overlay">
                
        <div class="loader">
            <img src="assets/redi/img/logo_min_krismar.webp" />
        </div>

    </div>
</ng-container>
